import {NotificationInteraction, type NotificationInteractionData} from "@/types/site_admin/notificationInteraction";

export class Maintenance {
    public id: number | null;
    public text: string;
    public email_text: string;
    public email_subject: string;
    public name: string;
    public extra_data: object;
    public admin_enabled: boolean;
    public client_enabled: boolean;
    public notification_sent: boolean;
    public from: Date | null;
    public until: Date | null;
    public notificationInteractions: NotificationInteraction[];

    constructor(data: MaintenanceData | void) {
        if (data === undefined) {
            this.id = null;
            this.text = "";
            this.email_text = "";
            this.email_subject = "";
            this.name = "";
            this.extra_data = {};
            this.admin_enabled = false;
            this.client_enabled = false;
            this.notification_sent = false;
            this.from = null;
            this.until = null;
            this.notificationInteractions = [];
        } else {
            this.id = data.id;
            this.text = data.text;
            this.email_text = data.email_text;
            this.email_subject = data.email_subject;
            this.name = data.name;
            this.admin_enabled = data.admin_enabled;
            this.client_enabled = data.client_enabled;
            this.extra_data = data.extra_data;
            if (this.extra_data.from) {
                this.extra_data.from = new Date(data.extra_data.from)
            }
            if (this.extra_data.until) {
                this.extra_data.until = new Date(data.extra_data.until)
            }
            this.notification_sent = data.notification_sent;
            this.from = null;
            if (data.from !== null) {
                this.from = new Date(data.from);
            }
            this.until = null;
            if (data.until !== null) {
                this.until = new Date(data.until);
            }
            this.notificationInteractions = [];
            if (data.notificationInteractions !== undefined) {
                data.notificationInteractions.forEach(notificationInteraction => this.notificationInteractions.push((new NotificationInteraction(notificationInteraction))));
            }
        }
    }

    serializeData(without_relations: boolean | Array<string> = false) {
        const serialized_data = {
            id: this.id,
            text: this.text,
            email_text: this.email_text,
            email_subject: this.email_subject,
            name: this.name,
            extra_data: this.extra_data,
            admin_enabled: this.admin_enabled,
            client_enabled: this.client_enabled,
            notification_sent: this.notification_sent,
            from: this.from,
            until: this.until
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('notificationInteractions')
            )
        ) {
            serialized_data.notificationInteractions = [];
            this.notificationInteractions.forEach(el => {
                serialized_data.notificationInteractions.push(el.serializeData())
            })
        }

        return serialized_data;
    }

    public resetToDefaults(): void {
        this.id = null;
        this.text = "";
        this.email_text = "";
        this.email_subject = "";
        this.name = "";
        this.extra_data = {};
        this.admin_enabled = false;
        this.client_enabled = false;
        this.notification_sent = false;
        this.from = null;
        this.until = null;
    }
}

export type MaintenanceData = {
    id: number | null;
    text: string;
    name: string;
    email_text: string;
    email_subject: string;
    admin_enabled: boolean;
    client_enabled: boolean;
    extra_data: object;
    notification_sent: boolean;
    from: Date | null;
    until: Date | null;
    notificationInteractions: NotificationInteractionData[];
}
